var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{staticClass:"cls-1",attrs:{"d":"M13.999,12.499 L12.499,13.999 L6.993,8.506 L1.499,13.999 L0.013,12.444 L5.479,6.996 L-0.001,1.530 L-0.001,1.499 L1.499,-0.001 L6.990,5.490 L12.499,-0.001 L13.999,1.499 L8.499,6.999 L13.999,12.499 Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }